import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';
import { useReveal } from '../../hooks/useReveal';

export default function PVFaqCta() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.08 });

  return (
    <section ref={ref} id="contato" className="section" style={{ background: 'var(--p2a-dark-bg)' }}>
      <div className="p2-container" style={{ textAlign: 'center', maxWidth: 680, margin: '0 auto' }}>
        <div className="eyebrow reveal" style={{ marginBottom: 20, justifyContent: 'center' }}>
          <span className="dot" />{t('pv.faq_cta.eyebrow')}
        </div>
        <h2 className="h-1 reveal">
          {t('pv.faq_cta.title_line1')} <span style={{ color: 'var(--p2a-green-400)' }}>{t('pv.faq_cta.title_line2_highlight')}</span>
        </h2>
        <p className="reveal" style={{ marginTop: 20, fontSize: 16, color: 'var(--p2a-dark-fg-2)' }}>
          {t('pv.faq_cta.lede')}
        </p>
        <div className="reveal" style={{ display: 'flex', gap: 12, marginTop: 32, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="https://pixviewer.cloud" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            {t('pv.faq_cta.cta_primary')} <Icon.External />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=5519996542014&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20a%20equipe%20da%20Pix2Agro%20sobre%20o%20PixViewer."
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-ghost"
          >
            {t('pv.faq_cta.cta_secondary')} <Icon.ArrowRight />
          </a>
        </div>
      </div>
    </section>
  );
}
